function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 1"
}, React.createElement("path", {
  fill: "#BFE6E5",
  className: "cls-2",
  d: "M10.91 18.18H11v8.32h-.09zM10.91 34.83H11v8.32h-.09zM10.91 51.47H11v8.32h-.09zM10.91 68.12H11v8.32h-.09zM10.91 84.76H11v8.32h-.09zM62.15 18.18H11v8.33h49.48l1.67-8.33zM11 43.15h46.13l1.67-8.32H11v8.32zM11 59.79h42.77l1.68-8.32H11v8.32zM11 76.44h39.42l1.68-8.32H11v8.32zM11 93.08h36.07l1.68-8.32H11v8.32z"
}), React.createElement("path", {
  fill: "#33C100",
  className: "cls-3 language",
  d: "M59.97 29.94H105v-8.32H61.65l-1.68 8.32zM56.61 46.59H105v-8.32H58.29l-1.68 8.32zM53.25 63.23H105v-8.32H54.93l-1.68 8.32zM49.89 79.88H105v-8.32H51.57l-1.68 8.32zM46.53 96.52H105V88.2H48.21l-1.68 8.32z"
}));

var SvgIcon4 = function SvgIcon4(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 115 115",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref3));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_4.58b7f0d4.svg";
export { ForwardRef as ReactComponent };